import {
  useState, Dispatch, SetStateAction, useEffect,
} from 'react';
import Icon from '../Icon/Icon';
import { IconKeys } from '../Icon/IconKeys';
import useOuterClick from '../../../utils/hooks/useOuterClick';
import useAutoFocus from '../../../utils/hooks/useAutoFocus';

import S from './SearchFilterStyles';

type Props = {
  filters: Record<string, string[]>;
  setFilters: Dispatch<SetStateAction<Record<string, string[]>>>;
  defaultText?: string;
};

function SearchFilter({
  filters, setFilters, defaultText,
}: Props): JSX.Element {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [text, setText] = useState<string>(defaultText || filters?.input?.[0] || '');
  const inputRef = useAutoFocus(isOpen);
  const innerRef = useOuterClick(() => {
    if (isOpen) {
      setIsOpen(false);
    }
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setText(e.target.value);
  };

  const handleSearchClick = (): void => {
    if (!isOpen) {
      setIsOpen(!isOpen);
      return;
    }

    const newFilters = { ...filters };
    newFilters.input = [text];
    setFilters(newFilters);
  };
  useEffect(() => {
    setText(defaultText as string);
  }, [defaultText]);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === 'Enter') {
      handleSearchClick();
    }
  };

  return (
    <S.Wrapper>
      <div
        ref={innerRef}
        className={`search-box ${isOpen ? 'open' : ''}`}
      >
        <button
          className="btn-search"
          type="button"
          onClick={handleSearchClick}
        >
          <Icon iconKey={IconKeys.SEARCH_SMALL} />
        </button>
        <input
          ref={inputRef}
          autoComplete="off"
          type="text"
          className="input-search"
          placeholder="Search here..."
          value={text || ''}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />
      </div>
    </S.Wrapper>
  );
}

export default SearchFilter;
